export const ToolResultBehaviorEnum = Object.freeze({
	PLAIN_REVIEW: "plainReview",
	SCORED_INTERPRETATION: "scoredInterpretation",
	PROFILE_COMPARISON: "profileComparison",
	TREND_REVIEW: "trendReview",
	WORKSHEET_REVIEW: "worksheetReview",
	ORDERED_REVIEW: "orderedReview",
	STATE_REVIEW: "stateReview",
	DERIVED_ANALYTICS: "derivedAnalytics",
})
